import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=51a48636&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=51a48636&prod&lang=css"
import style1 from "./Supplier.vue?vue&type=style&index=1&id=51a48636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a48636",
  null
  
)

export default component.exports